export class CreateApplicationNotesConstants {
    static STEP_TITLE = "Notes";
    static NOTE_FORM_CONTROL_NAME = "note";
    static ADD_NOTE_LABEL = "Note";
}
